import React, { useEffect, useState } from "react";

 const LanguageContext = React.createContext();

 const LanguageProvider = ({ children }) =>{
    const StorageLanguage = localStorage.getItem("language-partes");
    const WrongLanguage = (StorageLanguage===null || typeof StorageLanguage !== 'string' || StorageLanguage === 'undefined' || Array.isArray(StorageLanguage) || StorageLanguage === '[object Object]');

  let [language, setLanguage] = useState(WrongLanguage === true ? 'ES': StorageLanguage);

  useEffect(()=>{language && localStorage.setItem("language-partes",language);},[language])

  return (
    <LanguageContext.Provider
      value={{
        currentLanguage: language,
        setCurrentLanguage: (newLanguage) => setLanguage(newLanguage),
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

const useLanguageApp = () => {
  const context = React.useContext(LanguageContext);

  if (!context) {
    throw new Error(`LanguageContext debe ser usado dentro de StateAppProvider`);
  }

  return context;
}

export { LanguageProvider, useLanguageApp };